var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vi-home"},[(_vm.$route.path == '/' && _vm.$route.fullPath != '/#services')?_c('vi-home-hero-search'):_vm._e(),(_vm.$route.path == '/')?_c('vi-home-others'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }